import { useCallback } from 'react';
import { STORAGE_KEY, DEFAULT_EMPTY_ARRAY_JSON, DEFAULT_FALSE_JSON } from '../constants/userContextConstants';

export const useUserCache = () => {
    const saveToCache = useCallback((userData, modules, userGroups, isAdmin) => {
        localStorage.setItem(STORAGE_KEY.USER_DATA, JSON.stringify(userData));
        localStorage.setItem(STORAGE_KEY.USER_MODULES, JSON.stringify(modules));
        localStorage.setItem(STORAGE_KEY.USER_GROUPS, JSON.stringify(userGroups));
        localStorage.setItem(STORAGE_KEY.USER_IS_ADMIN, JSON.stringify(isAdmin));
    }, []);

    const loadFromCache = useCallback(() => {
        try {
            const cachedData = localStorage.getItem(STORAGE_KEY.USER_DATA);
            if (!cachedData) return null;

            const userData = JSON.parse(cachedData);
            const modules = JSON.parse(localStorage.getItem(STORAGE_KEY.USER_MODULES) || DEFAULT_EMPTY_ARRAY_JSON);
            const userGroups = JSON.parse(localStorage.getItem(STORAGE_KEY.USER_GROUPS) || DEFAULT_EMPTY_ARRAY_JSON);
            const isAdmin = JSON.parse(localStorage.getItem(STORAGE_KEY.USER_IS_ADMIN) || DEFAULT_FALSE_JSON);

            return { userData, modules, userGroups, isAdmin };
        } catch (error) {
            console.error('Failed to parse cached data:', error);
            return null;
        }
    }, []);

    const clearCache = useCallback(() => {
        localStorage.removeItem(STORAGE_KEY.USER_DATA);
        localStorage.removeItem(STORAGE_KEY.USER_MODULES);
        localStorage.removeItem(STORAGE_KEY.USER_GROUPS);
        localStorage.removeItem(STORAGE_KEY.USER_IS_ADMIN);
    }, []);

    return {
        saveToCache,
        loadFromCache,
        clearCache
    };
};
